
const mc = [
    {
        "r": 1,
        "c": 0,
        "v": {
            "v":'合计',
            "bl": 1, 
            'ht':0
        },
        "mc": {      
            "r": 1,  
            "c": 0,  
            "rs": 16, 
            "cs": 1  
        },
        
    }, 
    {
        "r": 17,
        "c": 0,
        "v": {
            "v":'T30',
            'ht':0,
            "bl": 1, 
            
        },
        "mc": {       
            "r": 17,   
            "c": 0,   
            "rs": 3, 
            "cs": 1   
        },
        
    },
    {
        "r": 29,
        "c": 0,
        "v": {
            "v":'T32',
            'ht':0,
            "bl": 1, 
            
        },
        "mc": {       
            "r": 29,   
            "c": 0,   
            "rs": 3, 
            "cs": 1   
        },
        
    },
   
]
const merge = {
    "1_0": {
        "r": 1,
        "c": 0,
        "rs": 16,
        "cs": 1
    },
    "17_0": {
        "r": 17,
        "c": 0,
        "rs": 3,
        "cs": 1
    },
    "29_0": {       
        "r": 29,   
        "c": 0,   
        "rs": 3, 
        "cs": 1   
    },
   
}
const firstHeader =[
    '车型','序号','科目名称','期初数','合计',
  
    
]
const border = [
    {
        "rangeType": "range",
        "borderType": "border-all",
        "style": "3",
        "color": "#a4a4a4",
        "range": [{
            "row": [0, 50],
            "column": [0, 23]
        }]
    },
]

export { firstHeader,border}